export default "__VITE_ASSET__BggVX1UR__"